export const environment = {
  production: false,
  zuoraApiUrl: 'https://sprucepowerzuoraapi-dev.azurewebsites.net',
  dwApiUrl: 'https://sprucepoweredwapi-dev.azurewebsites.net',
  managementApiUrl: 'https://sprucepowerauth0managedapi-dev.azurewebsites.net/user/',
  auth0ClientId: 'JX8LrCM60r6MYYpC5ozbUtbzpVPWkLWd',
  auth0Domain: 'auth.sprucepowerdev.com',
  auth0Audience: 'https://dev-506jdu5v1gxbxa34.us.auth0.com/api/v2/',
  scriptId: '170431335',
  skillNo: '4035448',
  emailApiURL: 'https://sprucepoweremailapi-dev.azurewebsites.net/sendemail',
  jobApplicationSourceUrl: 'https://spruce.applytojob.com/apply/embed/form/',
  jazzApiUrl: 'https://sprucepoweremailapi-dev.azurewebsites.net/jazzhr/jobopenings',
  subscriberPortalUrl: 'https://3282543.ecommerce.zuora.com',
  homeSaleApiURL: 'https://fa-spruceapi-dev.azurewebsites.net/api/v1/homesale/create',
  serviceNowApiBaseURL: 'https://sprucepoweremailapi-dev.azurewebsites.net',
  attachmentApiURL: 'https://fa-spruceapi-dev.azurewebsites.net/api/v1/homesale/upload-attachments',
  forwardingAddressApiURL: 'https://fa-spruceapi-dev.azurewebsites.net/api/v1/homesale/forwarding-address',
  validationApiBaseUrl: 'https://fa-spruceapi-dev.azurewebsites.net/api/v1'
};